<template>
  <PageLayout :page-title="$t('nav.products')" banner-key="product">
    <div class="productDiv product-page">
      <div class="product-page__inner wrap">
        <header class="product-page__head">
          <h1 class="product-page__title">{{ $t('nav.products') }}</h1>
        </header>

        <ProductCategoryNav :show-subs="false" />

        <div class="product-page__body" v-if="displayProducts.length">
          <div class="product-tiles">
            <router-link
              v-for="p in displayProducts"
              :key="p.id"
              :to="'/product/' + p.categorySlug + '/' + p.id + '.html'"
              class="product-tile"
            >
              <span class="product-tile__media">
                <img v-if="productImage(p)" :src="productImage(p)" :alt="p.productName">
              </span>
              <span class="product-tile__name">{{ $cleanBrand(p.productName) }}</span>
            </router-link>
          </div>
          <PagePagination
            :page="pageNum"
            :total="total"
            :page-size="pageSize"
            @change="onPageChange"
          />
        </div>
        <p v-else class="product-page__empty">{{ $t('common.noProducts') }}</p>
      </div>
    </div>
  </PageLayout>
</template>

<script>
import PageLayout from '@/components/hirays/PageLayout.vue'
import ProductCategoryNav from '@/components/hirays/ProductCategoryNav.vue'
import PagePagination from '@/components/hirays/PagePagination.vue'
import { listProductCategory, listProduct } from '@/utils/http'
import { unwrapRows, resolveImageUrl } from '@/utils/content'
import { DEFAULT_PAGE_SIZE, unwrapTotal, scrollToListTop } from '@/utils/pagination'

export default {
  components: { PageLayout, ProductCategoryNav, PagePagination },
  data() {
    return { displayProducts: [], pageNum: 1, pageSize: DEFAULT_PAGE_SIZE, total: 0 }
  },
  created() {
    this.load()
  },
  methods: {
    reloadCmsData() {
      this.load()
    },
    async load() {
      try {
        const [catRes, prodRes] = await Promise.all([
          listProductCategory({ status: 1, pageNum: 1, pageSize: 50 }, this.$i18n.locale),
          listProduct({ status: 1, pageNum: this.pageNum, pageSize: this.pageSize }, this.$i18n.locale)
        ])
        const cats = unwrapRows(catRes)
        const catMap = {}
        cats.forEach(c => { catMap[c.id] = c.categorySlug })
        const products = unwrapRows(prodRes)
        this.total = unwrapTotal(prodRes) || products.length
        if (products.length || this.total > 0) {
          this.displayProducts = products.map(p => ({
            ...p,
            categorySlug: catMap[p.categoryId] || 'product'
          }))
          return
        }
      } catch (e) { /* no static demo catalog */ }
      this.displayProducts = []
      this.total = 0
    },
    onPageChange(page) {
      this.pageNum = page
      this.load()
      scrollToListTop(this.$el.querySelector('.product-page__body') || this.$el)
    },
    productImage(p) {
      const url = (p.picUrl || '').split(',')[0] || ''
      return resolveImageUrl(url)
    }
  }
}
</script>
